import React from 'react';
import {
    Row,
    Col,
    Typography,
    Statistic,
    Table,
    Avatar,
    Divider,
} from 'antd';
import dayjs from 'dayjs';
import { formatPhone } from '../utils/customFunctions';
import logo from '../assets/tclogo.png';

export default function TransferDoc({ docData, printRef }) {
    // console.log(docType);
    return (
        <div ref={printRef}>
            {['ต้นฉบับ', 'สำเนา'].map((textDoc, idx) => <div key={idx} style={{
                background: '#FFF',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}

            >
                <div
                    style={{
                        // marginBottom: '8px',
                        // background: backGroundDocType(docType),
                        padding: '24px'
                    }}>
                    <Row justify='center'>
                        <Col xs={6} >
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>
                                    <Avatar src={logo} size={120} />
                                </div>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <Typography.Title level={5} style={{ margin: '0px', fontSize: '14px' }}>
                                บริษัท ธงชัย ไอที เซ็นเตอร์ จำกัด
                            </Typography.Title>
                            <Typography.Paragraph style={{ margin: '0px', fontSize: '12px' }}>
                                61/24-25 ตำบล พระปฐมเจดีย์ อำเภอ เมืองนครปฐม
                            </Typography.Paragraph>
                            <Typography.Paragraph style={{ margin: '0px', fontSize: '12px' }}>
                                จังหวัด นครปฐม 73000
                            </Typography.Paragraph>
                            <Typography.Paragraph style={{ margin: '0px', fontSize: '12px' }}>
                                โทรศัพท์ 034-343149 โทรศัพท์มือถือ {formatPhone('0894114746')}
                            </Typography.Paragraph>
                        </Col>
                        <Col flex={1} />
                        <Col>
                            <Typography.Paragraph style={{ textAlign: 'right', fontSize: '16px', margin: '0px', padding: '0px' }}>
                                ใบโอนสินค้าระหว่างสาขา
                            </Typography.Paragraph>
                            <div
                                style={{
                                    border: '1px solid #d9d9d9',
                                    textAlign: 'center',
                                    padding: '4px',
                                    borderRadius: '8px'
                                }}
                            >
                                {textDoc}
                            </div>
                        </Col>
                    </Row>
                </div>
                <Divider />
                <div style={{ padding: '24px' }}>
                    <Row justify="space-between">
                        <Col xs={14}>
                            <Row>
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        สาขาที่รับโอน
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {docData.customer.company}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={8}>
                                    <Typography.Text strong>
                                        ที่อยู่
                                    </Typography.Text>
                                </Col>
                                <Col>
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {docData.customer.address}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {`แขวง/ตำบล${docData.customer.sub_district} อำเภอ${docData.customer.district}`}
                                    </Typography.Text>
                                    <br />
                                    <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                        {`จังหวัด${docData.customer.province} รหัสไปรษณีย์ ${docData.customer.postalcode}`}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={10}>
                            <Row justify="end">
                                <Col xs={16}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                เลขที่
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                                {docData.doc_no}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={16}>
                                    <Row justify='space-between'>
                                        <Col >
                                            <Typography.Text strong>
                                                วันที่
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                                {dayjs(docData.order_date).format('DD-MM-YYYY')}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col xs={16}>
                                    <Row justify='space-between'>
                                        <Col>
                                            <Typography.Text strong>
                                                พนักงาน
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text type="secondary" style={{ color: "#000000e0" }}>
                                                {docData.employee.fname}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className='invoice-table-container'>
                    <Row gutter={[0, 24]}>
                        <Col xs={24}>
                            <Table
                                rowKey={(record) => record.id}
                                columns={[
                                    {
                                        title: 'รายการสินค้า',
                                        dataIndex: 'product',
                                        key: 'product',
                                        width: '80%',
                                        render: text => `${text?.name} ${text?.brand?.name} ${text?.description}`,

                                    },
                                    {
                                        title: 'ราคา',
                                        dataIndex: 'price',
                                        key: 'price',
                                        width: '10%',
                                        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                    {
                                        title: 'จำนวน',
                                        dataIndex: 'quantity',
                                        key: 'quantity',
                                        width: '10%',
                                        render: text => <Statistic value={text} valueStyle={{ fontSize: 14, textAlign: 'center' }} />
                                    },
                                    {
                                        title: 'ส่วนลด',
                                        dataIndex: 'discount',
                                        key: 'discount',
                                        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                    {
                                        title: 'รวม',
                                        dataIndex: 'total_price',
                                        key: 'total_price',
                                        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
                                    },
                                ]}
                                dataSource={docData.transaction_items}
                                pagination={false}
                            />
                        </Col>
                    </Row>
                </div>
                <div style={{ flex: 1 }} />
                <div style={{ padding: '24px' }}>
                    <Row justify="end" >
                        <Col xs={16}>
                            <Typography.Paragraph
                                strong
                                style={{
                                    margin: '0px',
                                    fontSize: '16px'
                                }}
                            >
                                เพิ่มเติม :
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{
                                    margin: '0px',
                                    fontSize: '14px'
                                }}
                            >
                                {docData.description ?? '-'}
                            </Typography.Paragraph>
                        </Col>
                        <Col xs={8} >
                            <Row justify='end'>
                                <Col>
                                    <Typography.Paragraph
                                        strong
                                        style={{
                                            margin: '0px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        รวมทั้งสิ้น
                                    </Typography.Paragraph>
                                </Col>
                                <Col>
                                    <Typography.Paragraph
                                        strong
                                        style={{
                                            margin: '0px 8px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        <Statistic
                                            value={docData.transaction_items.reduce((prev, cur) => (cur.quantity * cur.price) + prev, 0)}
                                            precision={2}
                                            valueStyle={{ fontSize: 16, fontWeight: 600, margin: '0px 8px' }}
                                        />
                                    </Typography.Paragraph>
                                </Col>
                                <Col>
                                    <Typography.Paragraph
                                        strong
                                        style={{
                                            margin: '0px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        บาท
                                    </Typography.Paragraph>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div style={{ padding: '24px' }}>
                    <Row justify="end">
                        <Col xs={8}></Col>
                        <Col style={{ marginLeft: '16px', textAlign: 'center' }}>
                            <Typography.Paragraph >
                                ผู้รับสินค้า :
                            </Typography.Paragraph>
                            <div style={{ width: '100%', height: '32px' }} />
                            <Typography.Paragraph >
                                -----/-----/-----
                            </Typography.Paragraph>
                        </Col>
                        <Col style={{ marginLeft: '16px', textAlign: 'center' }}>
                            <Typography.Paragraph >
                                ผู้ส่งสินค้า :
                            </Typography.Paragraph>
                            <div style={{ width: '100%', height: '32px' }} />
                            <Typography.Paragraph >
                                -----/-----/-----
                            </Typography.Paragraph>
                        </Col>
                    </Row>
                </div>
            </div>)}
        </div>
    )
}
